/**
 * What a staff member sees on a page their permissions do not open - said
 * plainly, with the way back, instead of a blank screen or a silent bounce.
 */

import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import { useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function NoAccess() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <SuiBox py={6} display="flex" justifyContent="center">
        <Card sx={{ p: 4, maxWidth: 460, textAlign: "center" }}>
          <Icon sx={{ fontSize: "48px !important", color: "#C9A227", mx: "auto" }}>lock</Icon>
          <SuiTypography variant="h5" mt={1}>
            ما عندك صلاحية لهاي الصفحة
          </SuiTypography>
          <SuiTypography variant="button" color="text" display="block" mt={1} mb={3}>
            You do not have permission to open this page. Ask an admin to give it to you from Users
            &gt; Permissions.
          </SuiTypography>
          <Button variant="contained" color="primary" onClick={() => navigate("/dashboard")}>
            الصفحة الرئيسية · Home
          </Button>
        </Card>
      </SuiBox>
    </DashboardLayout>
  );
}

export default NoAccess;
